import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getFuel(options = {}) {
	return _apiRequestWrap(
		ModulesMap.FUEL,
		ModulesConfigMap[ModulesMap.FUEL].GET_FUEL,
		options
	)
}
function _getFuelPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.FUEL,
		ModulesConfigMap[ModulesMap.FUEL].GET_FUEL_PREVIEW,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.FUEL].GET_FUEL]: _getFuel,
	[ModulesConfigMap[ModulesMap.FUEL].GET_FUEL_PREVIEW]: _getFuelPreview,

}